/* ==========================================================================
   matching-sets.js
   Handles: homepage/collection drawer + /pages/matching-set PDP
   ========================================================================== */

const IS_PDP = !!document.querySelector(".matching-set-page");

let state = {
  items: [],
  currentSet: null,
};

document.addEventListener("DOMContentLoaded", () => {
  if (IS_PDP) {
    bootPDP();
  } else {
    bootDrawer();
  }
});

async function injectReviews(set) {
  const groups = groupProducts(set.products);
  const container = document.querySelector(".ms-reviews-section");
  if (!container) return;

  container.innerHTML = `<h2 class="ms-reviews-section-heading">Customer Reviews</h2>`;

  const top = groups.top[0];
  const bottom = groups.bottom[0];

  if (top) await loadReviewBlock(top, "Top", container);
  if (bottom) await loadReviewBlock(bottom, "Bottom", container);
}


async function loadReviewBlock(product, label, container) {
  const wrapper = document.createElement("div");
  wrapper.className = "ms-reviews-block";
  wrapper.innerHTML = `<h3 class="ms-reviews-heading">${product.title}</h3><div class="ms-reviews-list">Loading…</div>`;
  container.appendChild(wrapper);
  const target = wrapper.querySelector(".ms-reviews-list");

  try {
    const res = await fetch(product.url);
    const html = await res.text();

    const data = extractReviewWidgetData(html, product.id);

    if (!data) {
      target.innerHTML = `<a href="${product.url}#judgeme_product_reviews" class="ms-review-link">No reviews yet.</a>`;
      return;
    }

    const rating = parseFloat(data.average_rating).toFixed(1);
    const count = data.number_of_reviews;
    const stars = "★".repeat(Math.round(rating)) + "☆".repeat(5 - Math.round(rating));

    const summaryHtml = `
      <div class="ms-review-summary-row">
        <span class="ms-review-stars">${stars}</span>
        <span class="ms-review-summary">${rating} out of 5 (${count} review${count === 1 ? "" : "s"})</span>
      </div>
    `;

    const reviews = data.reviews || [];
    const PAGE_SIZE = 5;

    const renderEntry = (r) => {
      const rStars = "★".repeat(r.rating) + "☆".repeat(5 - r.rating);
      const date = r.created_at
        ? new Date(r.created_at).toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })
        : "";
      const initial = (r.reviewer_name || "A").charAt(0).toUpperCase();
      return `
        <div class="ms-review-entry">
          <div class="ms-review-entry-stars">${rStars}</div>
          <div class="ms-review-entry-header">
            <div class="ms-review-avatar">${initial}</div>
            <div class="ms-review-entry-meta">
              <div class="ms-review-entry-name">${(r.reviewer_name || "Anonymous").toUpperCase()}</div>
              <div class="ms-review-entry-date">${date}</div>
            </div>
          </div>
          <div class="ms-review-entry-body">${r.body || ""}</div>
        </div>
      `;
    };

    target.innerHTML = summaryHtml + `<div class="ms-review-entries"></div>`;
    const entriesEl = target.querySelector(".ms-review-entries");
    entriesEl.dataset.shown = "0";

    const renderNextPage = () => {
      const shown = parseInt(entriesEl.dataset.shown, 10);
      const nextBatch = reviews.slice(shown, shown + PAGE_SIZE);
      nextBatch.forEach((r) => {
        entriesEl.insertAdjacentHTML("beforeend", renderEntry(r));
      });
      const newShown = shown + nextBatch.length;
      entriesEl.dataset.shown = newShown;

      const existingBtn = target.querySelector(".ms-review-see-more");
      if (existingBtn) existingBtn.remove();

      if (newShown < reviews.length) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ms-review-see-more";
        btn.textContent = `See more reviews (${reviews.length - newShown})`;
        btn.addEventListener("click", renderNextPage);
        target.appendChild(btn);
      }
    };

    renderNextPage();
  } catch (e) {
    console.error("Review load failed for", product.title, e);
    target.innerHTML = `<a href="${product.url}#judgeme_product_reviews" class="ms-review-link">Read reviews</a>`;
  }
}

function extractReviewWidgetData(html, productId) {
  const marker = `jdgm.data.reviewWidget[${productId}] = `;
  const startIdx = html.indexOf(marker);
  if (startIdx === -1) return null;

  const braceStart = html.indexOf("{", startIdx);
  if (braceStart === -1) return null;

  let depth = 0;
  let i = braceStart;
  for (; i < html.length; i++) {
    if (html[i] === "{") depth++;
    else if (html[i] === "}") {
      depth--;
      if (depth === 0) break;
    }
  }
  if (depth !== 0) return null;

  const jsonStr = html.slice(braceStart, i + 1);
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    console.error("JSON.parse failed:", e);
    return null;
  }
}

async function refreshReviews() {
  if (!IS_PDP) return;

  const set = state.currentSet;

  const groups = groupProducts(set.products);

  const topState = state.items.find(i => i.groupType === "top");
  const bottomState = state.items.find(i => i.groupType === "bottom");

  const reviewSet = {
    ...set,
    products: []
  };

  if (topState) {
    const top = groups.top.find(p => p.id == topState.productId);
    if (top) reviewSet.products.push(top);
  }

  if (bottomState) {
    const bottom = groups.bottom.find(p => p.id == bottomState.productId);
    if (bottom) reviewSet.products.push(bottom);
  }

  await injectReviews(reviewSet);
}

function bootDrawer() {
  document.querySelectorAll(".hotspot").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const setId = btn.dataset.set;
      const type = btn.dataset.type;
      const set = window.MATCHING_SETS[setId - 1];
      if (!set) return;
      showMiniCard(set, type, btn);
    });
  });

  document.querySelectorAll(".open-drawer").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const handle = btn.dataset.handle;
      const set = window.MATCHING_SETS.find((s) => s.handle === handle);
      if (!set) {
        console.error("Matching set not found:", handle);
        return;
      }
      sessionStorage.setItem("matching-set", JSON.stringify(set));
      window.location.href = `/pages/matching-set?handle=${handle}`;
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".mini-card") && !e.target.closest(".hotspot")) {
      document.querySelectorAll(".mini-card.show").forEach((c) => {
        c.classList.remove("show");
        c.closest(".matching-set-card").style.zIndex = "";
      });
    }
  });

  const drawer = document.getElementById("matching-drawer");
  if (drawer) {
    const closeBtn = drawer.querySelector(".drawer-close");
    const overlay = drawer.querySelector(".drawer-overlay");
    if (closeBtn) closeBtn.onclick = closeDrawer;
    if (overlay) overlay.onclick = closeDrawer;
    const cta = drawer.querySelector(".drawer-cta");
    if (cta) cta.addEventListener("click", addAllToCart);
  }

  const sharedSet = new URLSearchParams(window.location.search).get("set");
  if (sharedSet) {
    const set = window.MATCHING_SETS[parseInt(sharedSet) - 1];
    if (set) openDrawer(set);
  }

  document
    .querySelectorAll(".set-image img, .matching-set-card img")
    .forEach((img) => {
      const target =
        img.closest(".set-image") || img.closest(".matching-set-card");
      const onLoad = () => target?.classList.add("loaded");
      if (img.complete) onLoad();
      else img.addEventListener("load", onLoad);
    });
}

function waitForPdpImages() {
  const images = [
    document.getElementById("pdp-top-image"),
    document.getElementById("pdp-bottom-image"),
  ].filter(Boolean);

  return Promise.all(
    images.map((img) => {
      return new Promise((resolve) => {
        // Already loaded
        if (img.complete && img.naturalWidth > 0) {
          resolve();
          return;
        }

        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true });
      });
    }),
  );
}

async function bootPDP() {
  document.getElementById("matching-drawer")?.classList.remove("open");
  showPdpLoading(true);

  let set = null;

  const params = new URLSearchParams(window.location.search);
  const handle = params.get("handle");
  const urlTopColor = params.get("top_color");
  const urlBottomColor = params.get("bottom_color");
  const urlTopProduct = params.get("top_product");
  const urlBottomProduct = params.get("bottom_product");

  if (handle) {
    set = getSetByHandle(handle);
    if (set) {
      sessionStorage.setItem("matching-set", JSON.stringify(set));
    }
  }

  if (!set) {
    const stored = sessionStorage.getItem("matching-set");
    if (stored) {
      try {
        set = JSON.parse(stored);
      } catch (e) {
        console.error(e);
      }
    }
  }

  if (!set) {
    console.error("Matching set not found");
    showPdpLoading(false);
    document.querySelector(".matching-set-page")?.classList.add("ms-error");
    return;
  }

  window.MATCHING_SETS_PDP = set;

  document.querySelector(".matching-title").textContent = set.title;

  renderDrawer(
    set,
    { top: urlTopColor, bottom: urlBottomColor },
    { top: urlTopProduct, bottom: urlBottomProduct },
  );
  await injectReviews(set);
  syncSizeGuideProductIds();
  syncPdpImages();

  showPdpLoading(false);

  document
    .querySelector(".drawer-cta")
    ?.addEventListener("click", addAllToCart);
}

function getSetByHandle(handle) {
  try {
    const sets = window.MATCHING_SETS;
    if (Array.isArray(sets)) {
      return sets.find((s) => s.handle === handle) || null;
    }
  } catch (e) {
    console.error("MATCHING_SETS not available:", e);
  }
  return null;
}

function showPdpLoading(loading) {
  const page = document.querySelector(".matching-set-page");
  const panel = document.querySelector(".ms-panel");
  if (!page) return;

  if (loading) {
    page.classList.add("ms-loading");
    if (panel) panel.classList.add("ms-panel--loading");
  } else {
    page.classList.remove("ms-loading");
    if (panel) panel.classList.remove("ms-panel--loading");
  }
}

function openDrawer(set) {
  const drawer = document.getElementById("matching-drawer");
  if (!drawer) return;
  drawer.classList.add("open");
  renderDrawer(set);
  const url = new URL(window.location);
  url.searchParams.set("set", set.id);
  history.pushState({}, "", url);
}

function closeDrawer() {
  const drawer = document.getElementById("matching-drawer");
  if (!drawer) return;
  drawer.classList.remove("open");
  const url = new URL(window.location);
  url.searchParams.delete("set");
  history.pushState({}, "", url);
}

function syncSizeGuideProductIds() {
  const topItem = state.items.find((i) => i.groupType === "top");
  const bottomItem = state.items.find((i) => i.groupType === "bottom");
  const topSg = document.querySelector("#ms-size-guide-top .elvn-sg");
  const bottomSg = document.querySelector("#ms-size-guide-bottom .elvn-sg");
  if (topSg && topItem) topSg.dataset.productId = topItem.productId;
  if (bottomSg && bottomItem) bottomSg.dataset.productId = bottomItem.productId;
}

function renderDrawer(set, colorOverrides = {}, productOverrides = {}) {
  initState(set, colorOverrides, productOverrides);
  renderDrawerContent();
  updateTotal();
}

function renderDrawerContent() {
  const set = state.currentSet;
  const container = document.querySelector(".drawer-content");
  if (!container) return;

  const groups = groupProducts(set.products);
  const hasGroups = groups.top.length > 0 || groups.bottom.length > 0;

  let html = "";
  let allAlternates = [];

  if (hasGroups) {
    if (groups.top.length > 0) {
      const stateItem = state.items.find((i) => i.groupType === "top");
      const active =
        groups.top.find((p) => p.id == stateItem?.productId) || groups.top[0];
      allAlternates = allAlternates.concat(
        groups.top
          .filter((p) => p.id != active.id)
          .map((p) => ({ ...p, groupType: "top" })),
      );
      html += renderProductGroup("top", groups.top, set);
    }
    if (groups.bottom.length > 0) {
      const stateItem = state.items.find((i) => i.groupType === "bottom");
      const active =
        groups.bottom.find((p) => p.id == stateItem?.productId) ||
        groups.bottom[0];
      allAlternates = allAlternates.concat(
        groups.bottom
          .filter((p) => p.id != active.id)
          .map((p) => ({ ...p, groupType: "bottom" })),
      );
      html += renderProductGroup("bottom", groups.bottom, set);
    }
    groups.other.forEach((p) => {
      html += renderDrawerItem(p, "other", set);
    });
    if (allAlternates.length > 0)
      html += renderAlsoPairWith(allAlternates, set);
  } else {
    set.products.forEach((p) => {
      html += renderDrawerItem(p, "other", set);
    });
  }

  container.innerHTML = html;
  attachColorLogic();
  attachVariantLogic();
  attachSwapLogic();
  updateCTA();
  syncSizeGuideProductIds();
}

function renderProductGroup(groupType, products, set) {
  const stateItem = state.items.find((i) => i.groupType === groupType);
  const active =
    products.find((p) => p.id == stateItem?.productId) || products[0];
  const label = groupType === "top" ? "Top" : "Bottom";
  return `
       <div class="drawer-group" data-group="${groupType}">
         <div class="drawer-group-label">${label}</div>
         ${renderDrawerItem(active, groupType, set)}
       </div>
     `;
}

function renderDrawerItem(p, groupType, set) {
  const stateItem = state.items.find((i) => i.productId == p.id);

  const colorMap = {};
  p.variants.forEach((v) => {
    const color = v.color || v.title.split("/")[0].trim();
    const size = v.size || v.title.split("/").slice(1).join("/").trim();
    if (!colorMap[color]) colorMap[color] = [];
    colorMap[color].push({ id: v.id, size, available: v.available });
  });

  const colors = Object.keys(colorMap);
  const defaultColor = stateItem?.selectedColor || colors[0];
  const sizes = colorMap[defaultColor] || [];
  const img =
    findColorImage(p.colorImages, defaultColor) ||
    p.featured_image ||
    set.image;
  const productUrl = p.url || `/products/${p.handle}`;

  const thumbHtml = !IS_PDP
    ? `<a href="${productUrl}" class="drawer-item-img-link" aria-label="View ${p.title}">
           <img src="${img}" alt="${p.title}" data-product-img="${p.id}" loading="lazy" />
         </a>`
    : "";

  const sgType =
    groupType === "top" || groupType === "tops"
      ? "top"
      : groupType === "bottom" || groupType === "bottoms"
        ? "bottom"
        : null;

  const sizeGuideHtml =
  IS_PDP && sgType
    ? ""
    // `
    //   <open-or-scroll-to
    //     data-target-id="ms-size-guide-${sgType}"
    //     data-product-type="${sgType}">
    //     <button type="button" class="link size-guide-link size-chart-link">
    //       <span class="size-chart-link__text">Find my size</span>
    //     </button>
    //   </open-or-scroll-to>
    // `
    : `
      <a href="${productUrl}" class="size-guide-link">
        Size Guide
      </a>
    `;

  return `
       <div class="drawer-item" data-product="${p.id}" data-group="${groupType || ""}">
         ${thumbHtml}
         <div class="drawer-info">
           <div class="drawer-name">
             <a href="${productUrl}" class="drawer-name-link">${p.title}</a>
           </div>
           <div class="drawer-item-price">${formatPrice(p.price)}</div>
           <div class="color-row">
             ${colors
               .map(
                 (c) => `
               <button class="color-btn ${c === defaultColor ? "active" : ""}"
                 data-color="${c}" data-product="${p.id}">${c}</button>
             `,
               )
               .join("")}
           </div>
           <div class="size-label-row">
             <span class="size-label">Size</span>
             ${sizeGuideHtml}
           </div>
           <div class="variant-row">
             ${sizes
               .map((v, i) => {
                 const available = v.available !== false;
                 return `<button
                 class="variant-btn ${i === 0 ? "active" : ""} ${!available ? "disabled" : ""}"
                 data-variant="${v.id}" data-product="${p.id}"
                 ${!available ? "disabled" : ""}>${v.size}</button>`;
               })
               .join("")}
           </div>
         </div>
       </div>
     `;
}

function renderAlsoPairWith(products, set) {
  const items = products
    .map((p) => {
      const stateItem = state.items.find((i) => i.groupType === p.groupType);
      const activeColor = stateItem?.selectedColor;
      const img =
        findColorImage(p.colorImages, activeColor) ||
        p.featured_image ||
        set.image;
      const typeLabel = p.groupType === "top" ? "Top" : "Bottom";
      return `
         <div class="also-pair-item" data-product-id="${p.id}" data-group="${p.groupType}">
           <button class="also-pair-swap" data-product-id="${p.id}" data-group="${p.groupType}"
             aria-label="Swap to ${p.title}">
             <div class="also-pair-img-wrap">
               <img src="${img}" alt="${p.title}" loading="lazy" />
             </div>
             <div class="also-pair-info">
               <span class="also-pair-name">${p.title}</span>
               <span class="also-pair-type">${typeLabel}</span>
             </div>
           </button>
         </div>
       `;
    })
    .join("");

  return `
       <div class="also-pair-section">
         <div class="also-pair-header">
           <span class="also-pair-divider"></span>
           <span class="also-pair-label">Also pair with</span>
           <span class="also-pair-divider"></span>
         </div>
         <div class="also-pair-options">${items}</div>
       </div>
     `;
}

function attachColorLogic() {
  document.querySelectorAll(".color-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const parent = btn.closest(".drawer-item");
      const productId = btn.dataset.product;
      const selectedColor = btn.dataset.color;
      const groupType = parent.dataset.group;

      parent
        .querySelectorAll(".color-btn")
        .forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const set = state.currentSet;
      const product = set.products.find((p) => p.id == productId);
      if (!product) return;

      const newImg = findColorImage(product.colorImages, selectedColor);

      const thumbEl = parent.querySelector(`[data-product-img="${productId}"]`);
      if (thumbEl && newImg) thumbEl.src = newImg;

      if (IS_PDP && newImg) {
        const imgEl = document.querySelector(
          groupType === "top" ? "#pdp-top-image" : "#pdp-bottom-image",
        );
        if (imgEl) {
          imgEl.src = newImg;
          imgEl.closest(".ms-gallery__block")?.classList.add("loaded");
        }

        const linkEl = document.querySelector(
          groupType === "top" ? "#pdp-top-link" : "#pdp-bottom-link",
        );
        if (linkEl) linkEl.href = product.url || `/products/${product.handle}`;
      }

      const colorMap = {};
      product.variants.forEach((v) => {
        const color = v.color || v.title.split("/")[0].trim();
        const size = v.size || v.title.split("/").slice(1).join("/").trim();
        if (!colorMap[color]) colorMap[color] = [];
        colorMap[color].push({ id: v.id, size, available: v.available });
      });
      const sizes = colorMap[selectedColor] || [];

      parent.querySelector(".variant-row").innerHTML = sizes
        .map((v, i) => {
          const available = v.available !== false;
          return `<button
             class="variant-btn ${i === 0 ? "active" : ""} ${!available ? "disabled" : ""}"
             data-variant="${v.id}" data-product="${productId}"
             ${!available ? "disabled" : ""}>${v.size}</button>`;
        })
        .join("");

      const stateItem = state.items.find((i) => i.productId == productId);
      const firstAvailable = sizes.find((v) => v.available !== false);
      if (stateItem) {
        stateItem.selectedColor = selectedColor;
        stateItem.variantId = firstAvailable?.id || null;
      }

      if (IS_PDP) {
        const url = new URL(window.location);
        url.searchParams.set(
          groupType === "top" ? "top_color" : "bottom_color",
          selectedColor,
        );
        history.pushState({}, "", url);
      }

      updateAlsoPairThumbnails(groupType, selectedColor);
      attachVariantLogic();
      updateTotal();
    });
  });
}

function attachVariantLogic() {
  document.querySelectorAll(".variant-btn:not([disabled])").forEach((btn) => {
    btn.addEventListener("click", () => {
      const parent = btn.closest(".drawer-item");
      const productId = btn.dataset.product;
      const variantId = btn.dataset.variant;
      parent
        .querySelectorAll(".variant-btn")
        .forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      const item = state.items.find((i) => i.productId == productId);
      if (item) item.variantId = variantId;
    });
  });
}

function attachSwapLogic() {
  document.querySelectorAll(".also-pair-swap").forEach((btn) => {
    btn.addEventListener("click", () => {
      const productId = btn.dataset.productId;
      const groupType = btn.dataset.group;
      const set = state.currentSet;
      const newProduct = set.products.find((p) => p.id == productId);
      if (!newProduct) return;

      const firstVariant = newProduct.variants[0];
      const color =
        firstVariant.color || (firstVariant.title || "").split("/")[0].trim();

      const idx = state.items.findIndex((i) => i.groupType === groupType);
      const newItem = {
        productId: newProduct.id,
        variantId: firstVariant.id,
        selectedColor: color,
        price: newProduct.price,
        groupType,
      };
      if (idx >= 0) state.items[idx] = newItem;
      else state.items.push(newItem);

      if (IS_PDP) {
        const url = new URL(window.location);
        url.searchParams.set(
          groupType === "top" ? "top_product" : "bottom_product",
          newProduct.id,
        );
        url.searchParams.set(
          groupType === "top" ? "top_color" : "bottom_color",
          color,
        );
        history.pushState({}, "", url);
      }

      renderDrawerContent();
      updateTotal();

      if (IS_PDP) {
        syncPdpImages();
        refreshReviews();
      }
    });
  });
}

function syncPdpImages() {
  const set = state.currentSet;
  if (!set) return;

  const groups = groupProducts(set.products);

  const syncImage = (product, selectedColor, elId) => {
    if (!product) return;
    const src =
      findColorImage(product.colorImages, selectedColor) ||
      product.featured_image ||
      set.image;

    const el = document.querySelector(elId);
    if (!el) return;
    el.src = src;
    el.alt = product.title;

    const linkId = elId === "#pdp-top-image" ? "#pdp-top-link" : "#pdp-bottom-link";
    const linkEl = document.querySelector(linkId);
    if (linkEl) linkEl.href = product.url || `/products/${product.handle}`;


    const block = el.closest(".ms-gallery__block");
    if (el.complete && el.naturalWidth > 0) {
      block?.classList.add("loaded");
    } else {
      el.addEventListener(
        "load",
        () => {
          block?.classList.add("loaded");
        },
        { once: true },
      );

      el.addEventListener(
        "error",
        () => {
          block?.classList.add("loaded");
        },
        { once: true },
      );
    }
  };


  const topState = state.items.find((i) => i.groupType === "top");
  const bottomState = state.items.find((i) => i.groupType === "bottom");

  const topProduct = set.products.find((p) => p.id == topState?.productId);
  const bottomProduct = set.products.find(
    (p) => p.id == bottomState?.productId,
  );

  syncImage(
    topProduct,
    topState?.selectedColor || set.default_top_color,
    "#pdp-top-image",
  );

  syncImage(
    bottomProduct,
    bottomState?.selectedColor || set.default_bottom_color,
    "#pdp-bottom-image",
  );
}

function showMiniCard(set, type, anchor) {
  const groups = groupProducts(set.products);
  const product =
    type === "top"
      ? groups.top[0] || set.products[0]
      : groups.bottom[0] || groups.top[0] || set.products[0];
  if (!product) return;

  const card = anchor.closest(".matching-set-card");
  const miniCard = card?.querySelector(".mini-card");
  if (!miniCard) return;

  document.querySelectorAll(".mini-card.show").forEach((c) => {
    c.classList.remove("show");
    c.closest(".matching-set-card").style.zIndex = "";
  });
  card.style.zIndex = "1";

  const defaultColor =
    type === "top" ? set.default_top_color : set.default_bottom_color;
  const thumbImg =
    findColorImage(product.colorImages, defaultColor) ||
    product.featured_image ||
    set.image;

  miniCard.innerHTML = `
       <div class="mini-card-inner">
         <div class="mini-left"><img src="${thumbImg}" alt="${product.title}" /></div>
         <div class="mini-right">
           <div class="mini-title">${product.title}</div>
           <div class="mini-price">${formatPrice(product.price)}</div>
           <button class="mini-view">View Set</button>
         </div>
       </div>
     `;

  miniCard.style.cssText = "top:0;left:0;visibility:hidden;";
  miniCard.classList.add("show");
  const mH = miniCard.offsetHeight;
  miniCard.style.visibility = "";

  const MINI_W = 220,
    OFFSET = 10;
  const hotspotRect = anchor.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  const imageRect = anchor.closest(".set-image").getBoundingClientRect();
  const gridRect = card.parentElement.getBoundingClientRect();

  let viewTop = hotspotRect.bottom + 8;
  if (viewTop + mH > imageRect.bottom - OFFSET)
    viewTop = hotspotRect.top - mH - 8;
  if (viewTop < imageRect.top + OFFSET) viewTop = imageRect.top + OFFSET;

  const hotCX = hotspotRect.left + anchor.offsetWidth / 2;
  let viewLeft = hotCX - MINI_W / 2;
  if (viewLeft < gridRect.left + OFFSET) viewLeft = gridRect.left + OFFSET;
  if (viewLeft + MINI_W > gridRect.right - OFFSET)
    viewLeft = gridRect.right - MINI_W - OFFSET;

  miniCard.style.top = `${viewTop - cardRect.top}px`;
  miniCard.style.left = `${viewLeft - cardRect.left}px`;

  miniCard.querySelector(".mini-view").onclick = () => {
    miniCard.classList.remove("show");
    sessionStorage.setItem("matching-set", JSON.stringify(set));
    window.location.href = `/pages/matching-set?handle=${set.handle}`;
  };
}

function initState(set, colorOverrides = {}, productOverrides = {}) {
  state.currentSet = set;
  state.items = [];

  const groups = groupProducts(set.products);
  const hasGroups = groups.top.length > 0 || groups.bottom.length > 0;

  if (hasGroups) {
    [
      {
        groupType: "top",
        products: groups.top,
        defaultColor: colorOverrides.top || set.default_top_color,
        productId: productOverrides.top,
      },
      {
        groupType: "bottom",
        products: groups.bottom,
        defaultColor: colorOverrides.bottom || set.default_bottom_color,
        productId: productOverrides.bottom,
      },
    ].forEach(({ groupType, products, defaultColor, productId }) => {
      if (!products.length) return;
      const p = productId
        ? products.find((pr) => pr.id == productId) || products[0]
        : products[0];
      const chosenVariant = pickVariantForColor(p, defaultColor);
      const color =
        chosenVariant.color || chosenVariant.title.split("/")[0].trim();
      state.items.push({
        productId: p.id,
        variantId: chosenVariant.id,
        selectedColor: color,
        price: p.price,
        groupType,
      });
    });
    groups.other.forEach((p) => {
      const v = p.variants[0];
      const color = v.color || v.title.split("/")[0].trim();
      state.items.push({
        productId: p.id,
        variantId: v.id,
        selectedColor: color,
        price: p.price,
        groupType: "other",
      });
    });
  } else {
    set.products.forEach((p) => {
      const v = p.variants[0];
      const color = v.color || v.title.split("/")[0].trim();
      state.items.push({
        productId: p.id,
        variantId: v.id,
        selectedColor: color,
        price: p.price,
        groupType: "other",
      });
    });
  }
}
async function addAllToCart() {
  const items = state.items
    .filter((i) => i.variantId)
    .map((i) => ({ id: i.variantId, quantity: 1 }));
  if (!items.length) return;

  const cta = document.querySelector(".drawer-cta");
  try {
    if (cta) {
      cta.textContent = "Adding...";
      cta.disabled = true;
    }

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error("Cart error");

    if (cta) cta.textContent = "Added ✓";
    if (typeof window.elvnBumpCartCount === "function")
      window.elvnBumpCartCount(items.length);

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      const html = await fetch("/?section_id=cart-drawer").then((r) =>
        r.text(),
      );
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const newDrawer = temp.querySelector("cart-drawer");
      if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
      cartDrawer.open?.();
    }

    if (!IS_PDP) closeDrawer();
  } catch (err) {
    console.error(err);
    if (cta) cta.textContent = "Error – try again";
  } finally {
    setTimeout(() => {
      if (cta) {
        cta.textContent = "Add Full Look to Cart";
        cta.disabled = false;
      }
    }, 2000);
  }
}

function groupProducts(products) {
  const tops = [],
    bottoms = [],
    other = [];
  (products || []).forEach((p) => {
    const t = (p.type || "").toLowerCase().trim();
    if (t === "top" || t === "tops") tops.push(p);
    else if (t === "bottom" || t === "bottoms") bottoms.push(p);
    else other.push(p);
  });
  return { top: tops, bottom: bottoms, other };
}

function pickVariantForColor(product, wantedColor) {
  if (!wantedColor) return product.variants[0];
  return (
    product.variants.find(
      (v) => (v.color || "").trim().toLowerCase() === wantedColor.toLowerCase(),
    ) || product.variants[0]
  );
}

function findColorImage(colorImages, color) {
  if (!colorImages || !color) return null;
  if (colorImages[color]) return colorImages[color];
  const lower = color.toLowerCase();
  const key = Object.keys(colorImages).find((k) => k.toLowerCase() === lower);
  return key ? colorImages[key] : null;
}

function updateAlsoPairThumbnails(groupType, color) {
  const set = state.currentSet;
  document
    .querySelectorAll(`.also-pair-item[data-group="${groupType}"]`)
    .forEach((item) => {
      const product = set.products.find((p) => p.id == item.dataset.productId);
      if (!product) return;
      const img = item.querySelector("img");
      const src = findColorImage(product.colorImages, color);
      if (img && src) img.src = src;
    });
}

function updateTotal() {
  const total = state.items.reduce((sum, i) => sum + i.price, 0);
  document.querySelectorAll(".total").forEach((el) => {
    el.textContent = formatPrice(total);
  });
}

function updateCTA() {
  const cta = document.querySelector(".drawer-cta");
  if (cta) cta.textContent = "Add Full Look to Cart";
}

function formatPrice(price) {
  return (
    "₹" +
    (price / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

function copySetLink() {
  const url = window.location.href;
  navigator.clipboard
    .writeText(url)
    .then(() => {
      const btn = document.querySelector(".drawer-share-btn");
      const tickEl = document.getElementById("drawer-tick-icon");
      if (!btn || !tickEl) return;
      const orig = btn.innerHTML;
      btn.innerHTML = tickEl.innerHTML;
      setTimeout(() => {
        btn.innerHTML = orig;
      }, 2000);
    })
    .catch(() => {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.cssText = "position:fixed;opacity:0;";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    });
}
